import { withStyles } from '@material-ui/core/styles'
import React from 'react'
import { connect } from 'react-redux'
import { authorization } from '../../../../../Module/Auth/Auth'
import CampaignPage from '../../index'
import AdminView from './AdminView'
import ClientView from './ClientView'
import styles from './styles'

const Codes = ({ match, nav, history, classes, campaign }) => {
  const { campaignId } = match.params
  const user = authorization.getUser()
  const isAdmin = user.role === 'ADMIN'

  return (
    <CampaignPage
      active={nav}
      history={history}
      match={match}
      campaignId={campaignId}
    >
      {isAdmin ? <AdminView /> : <ClientView />}
    </CampaignPage>
  )
}

const mapStateToProps = (state, props) => ({
  campaign: state.campaigns.campaigns[props.match.params.campaignId],
  state: state,
})

export default connect(mapStateToProps)(withStyles(styles)(Codes))
